import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Moment from 'moment';
import { getActiveLanguage } from '@haldor/ui';
var DateSpan = /*#__PURE__*/function (_Component) {
  function DateSpan() {
    var _this;
    _classCallCheck(this, DateSpan);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DateSpan, [].concat(args));
    _defineProperty(_this, "getDateString", function (date) {
      return Moment.utc(date).local().format('D MMM');
    });
    _defineProperty(_this, "formatDate", function () {
      Moment.locale(getActiveLanguage());
      return /*#__PURE__*/React.createElement("span", null, _this.getDateString(_this.props.start), " - ", _this.getDateString(_this.props.end));
    });
    _defineProperty(_this, "icon", function () {
      return /*#__PURE__*/React.createElement("svg", {
        id: "Lager_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        xmlSpace: "preserve",
        viewBox: "0 0 12 12"
      }, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.st0{fill:none;stroke:#1D1D1B;stroke-width:1.2756;stroke-linecap:round;stroke-miterlimit:10;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
        className: "st0",
        cx: "6",
        cy: "6.7",
        r: "4.4"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "3.9",
        x2: "6",
        y2: "6.7"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "2.1",
        x2: "6",
        y2: "1.1"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "5.1",
        y1: "0.8",
        x2: "6.9",
        y2: "0.8"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "6.7",
        x2: "7.3",
        y2: "5.6"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "9.4",
        y1: "3.8",
        x2: "10.1",
        y2: "3.2"
      })));
    });
    return _this;
  }
  _inherits(DateSpan, _Component);
  return _createClass(DateSpan, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("time", {
        className: "from-now card-meta",
        dateTime: this.props.start
      }, this.props.icon ? this.icon() : null, this.formatDate());
    }
  }]);
}(Component);
export { DateSpan as default };